import React from "react";
import Calendar from "react-calendar/dist/entry.nostyle";
import { func, instanceOf, bool, arrayOf, oneOfType } from "prop-types";

import "./calendar.m.css";

const CustomCalendar = ({ onChange, onClickApply, maxDate, value, selectRange }) => {
  const formatMonth = (locale, date) => date.toLocaleString("default", { month: "short" });

  return (
    <div styleName="wrapper">
      <Calendar
        minDetail="decade"
        maxDate={maxDate}
        formatMonth={formatMonth}
        onChange={onChange}
        value={value}
        selectRange={selectRange}
      />
      <div styleName="button-wrapper">
        <button styleName="button" onClick={onClickApply}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default CustomCalendar;

CustomCalendar.propTypes = {
  onChange: func,
  onClickApply: func,
  maxDate: instanceOf(Date),
  value: oneOfType([instanceOf(Date), arrayOf(instanceOf(Date))]),
  selectRange: bool
};
